// app/javascript/pages/catalog.js

function initializeCatalog() {
  const desktopNavElement = document.getElementById('desktopBrandNav');
  const bodyElement = document.body;
  let scrollSpy = null;

  const getBaseOffset = () => {
    const offsetValue = getComputedStyle(document.documentElement).getPropertyValue('--scroll-margin-offset').trim();
    return parseInt(offsetValue.replace('px', ''), 10) || 100;
  };

  const basePageOffset = getBaseOffset();
  const effectiveScrollAndSpyOffset = Math.max(0, basePageOffset - 50);

  if (desktopNavElement) {
    try {
      scrollSpy = new bootstrap.ScrollSpy(bodyElement, {
        target: '#desktopBrandNav',
        offset: effectiveScrollAndSpyOffset,
        method: 'position'
      });
    } catch (e) {
      console.error("Error initializing ScrollSpy:", e);
      scrollSpy = null;
    }
  }

  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      const clickedLinkElement = this;
      const targetHref = clickedLinkElement.getAttribute('href');
      const targetElement = document.querySelector(targetHref);
      const DSK_NAV_SELECTOR = '#desktopBrandNav';
      const MBL_OFFCANVAS_SELECTOR = '.offcanvas'; // More generic for mobile offcanvas

      if (targetElement) {
        const offsetTop = targetElement.getBoundingClientRect().top + window.pageYOffset - effectiveScrollAndSpyOffset;
        const offcanvasElement = clickedLinkElement.closest(MBL_OFFCANVAS_SELECTOR);

        if (offcanvasElement && offcanvasElement.id === 'mobileBrandNav') { // Check if it's the mobile brand navigation offcanvas
          const offcanvasInstance = bootstrap.Offcanvas.getInstance(offcanvasElement);
          if (offcanvasInstance) {
            // Listen for the offcanvas to be fully hidden, then scroll
            offcanvasElement.addEventListener('hidden.bs.offcanvas', function onOffcanvasHidden() {
              window.scrollTo({
                top: offsetTop,
                behavior: 'smooth'
              });
              // Listener removed automatically by { once: true }
            }, { once: true }); // Ensure the listener is called only once

            offcanvasInstance.hide();
          } else {
            // Fallback if offcanvas instance not found (should not happen with correct markup)
            window.scrollTo({ top: offsetTop, behavior: 'smooth' });
          }
        } else {
          // Handling for desktop links or other anchor links not in the specified mobile offcanvas
          window.scrollTo({
            top: offsetTop,
            behavior: 'smooth'
          });

          // Desktop ScrollSpy refresh and correction logic
          if (clickedLinkElement.closest(DSK_NAV_SELECTOR) && scrollSpy) {
            setTimeout(() => {
              scrollSpy.refresh();
              const scrollSpyActiveLink = document.querySelector(`${DSK_NAV_SELECTOR} .nav-link.active`);
              if (scrollSpyActiveLink !== clickedLinkElement) {
                const scrollSpyChosenHref = scrollSpyActiveLink ? scrollSpyActiveLink.getAttribute('href') : 'none';
                console.warn(`ScrollSpy Correction: Clicked ${targetHref}, ScrollSpy chose ${scrollSpyChosenHref}. Forcing ${targetHref} to be active.`);
                if (scrollSpyActiveLink) {
                  scrollSpyActiveLink.classList.remove('active');
                }
                clickedLinkElement.classList.add('active');
              } else {
                // console.log(`ScrollSpy OK: ${targetHref} is correctly active after refresh.`);
              }
            }, 750); // Adjust timeout based on smooth scroll duration
          }
        }
      }
    });
  });

  // Enhanced brand search functionality (structure from your original code)
  function setupBrandSearch(searchInputEl, navItemsNodeList) {
    if (!searchInputEl || !navItemsNodeList || navItemsNodeList.length === 0) return;

    searchInputEl.addEventListener('input', function() {
      const searchTerm = this.value.toLowerCase().trim();
      let visibleItemsCount = 0;

      navItemsNodeList.forEach(item => { // item is li.nav-item
        const brandName = item.dataset.brand || ''; // data-brand is on li.nav-item
        const shouldShow = brandName.toLowerCase().includes(searchTerm);
        item.style.display = shouldShow ? 'block' : 'none'; // 'block' or revert to default with ''

        if (shouldShow) {
            visibleItemsCount++;
            if (searchTerm) { // Add highlight only if there's a search term
                item.classList.add('search-highlight');
            } else {
                item.classList.remove('search-highlight');
            }
        } else {
            item.classList.remove('search-highlight');
        }
      });

      const container = navItemsNodeList[0]?.parentElement; // UL element
      let noResultsMessage = container?.querySelector('.no-results-message');

      if (visibleItemsCount === 0 && searchTerm) {
        if (!noResultsMessage && container) {
          noResultsMessage = document.createElement('li');
          noResultsMessage.className = 'no-results-message text-center py-3 text-muted list-unstyled'; // list-unstyled to remove bullets if it's a ul
          noResultsMessage.innerHTML = '<small><i class="fas fa-search me-2"></i>No brands found</small>';
          container.appendChild(noResultsMessage);
        }
      } else if (noResultsMessage) {
        noResultsMessage.remove();
      }
    });
  }

  const desktopSearchInput = document.getElementById('brandSearch');
  const desktopNavItems = document.querySelectorAll('#brandNavLinks .nav-item');
  setupBrandSearch(desktopSearchInput, desktopNavItems);

  const mobileSearchInput = document.getElementById('mobileBrandSearch');
  const mobileNavItems = document.querySelectorAll('#mobileBrandNavLinks .nav-item');
  setupBrandSearch(mobileSearchInput, mobileNavItems);


  // Click on backdrop to close mobile offcanvas (from your original code)
  // Bootstrap handles this by default, but explicit handling can be kept if specific behavior is needed.
  const mobileOffcanvasElement = document.getElementById('mobileBrandNav');
  if (mobileOffcanvasElement) {
    mobileOffcanvasElement.addEventListener('click', function(e) {
      if (e.target === this) { // Ensure click is on the backdrop itself
        const instance = bootstrap.Offcanvas.getInstance(this);
        if (instance) { instance.hide(); }
      }
    });
  }

  // Product image lazy load and error handling
  document.querySelectorAll('.product-image:not(.placeholder-fallback)').forEach(img => {
    // Set initial style for transition. This can also be done in CSS for .product-image.
    img.style.transition = 'opacity 0.5s ease-in-out';

    img.addEventListener('load', function() {
        this.style.opacity = '1';
    });

    img.addEventListener('error', function() {
        const container = this.closest('.product-image-container');
        if (container) {
            const originalAlt = this.alt || 'Image load error';
            // Using placehold.co as requested.
            // The new img tag gets 'product-image' for layout and 'placeholder-fallback' to identify it.
            container.innerHTML = `<img src="https://placehold.co/200x200/CCCCCC/333333?text=Error&font=montserrat" 
                                        alt="${originalAlt}" 
                                        class="product-image placeholder-fallback" 
                                        style="opacity:1; width:100%; height:auto; aspect-ratio: 1/1; object-fit:cover;">`;
        }
    });

    if (img.complete) { // If image is already loaded (e.g., from cache)
        if (img.naturalHeight === 0 && img.naturalWidth === 0) { // Check if it's a broken image link
            img.dispatchEvent(new Event('error'));
        } else { // Valid cached image
            img.style.opacity = '1'; // Show immediately
        }
    } else {
        img.style.opacity = '0'; // Not complete, start transparent for fade-in on load
    }
  });

  // Intersection observer for product card animation (from your original code)
  const observerOptions = { threshold: 0.1, rootMargin: '0px 0px -50px 0px' };
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) { 
        entry.target.style.animation = 'fadeInUp 0.6s ease forwards'; 
        // observer.unobserve(entry.target); // Optional: unobserve after first animation
      }
    });
  }, observerOptions);

  document.querySelectorAll('.product-card').forEach(card => {
    card.style.opacity = '0'; // Initial state for animation
    card.style.transform = 'translateY(20px)'; // Initial state for animation
    observer.observe(card);
  });

  // Dynamic keyframes and styles (from your original code, made idempotent)
  const dynamicStylesId = 'dynamic-catalog-styles';
  if (!document.getElementById(dynamicStylesId)) {
    const style = document.createElement('style');
    style.id = dynamicStylesId;
    style.textContent = `
        @keyframes fadeInUp { 
            to { opacity: 1; transform: translateY(0); } 
        }
        .search-highlight .brand-name { /* Target the text span for better visual feedback */
            /* Example: background-color: yellow; */
            font-weight: bold; /* Or some other highlight */
        } 
        /* The pulse animation might be too much for list items, 
           but keeping it if you prefer. Consider applying to a smaller element or text. */
        .search-highlight { 
            animation: pulse 0.8s ease-in-out; 
        }
        @keyframes pulse { 
            0% { transform: scale(1); } 
            50% { transform: scale(1.015); } /* Subtle pulse */
            100% { transform: scale(1); } 
        }
        .product-image.placeholder-fallback { /* Ensure fallback images fit well */
            width: 100%; 
            height: auto; 
            aspect-ratio: 1/1; 
            object-fit: cover; 
        }
    `;
    document.head.appendChild(style);
  }
}

export default initializeCatalog;